import { render } from "./elecBoardContainer.vue?vue&type=template&id=563520f0&scoped=true"
import script from "./elecBoardContainer.vue?vue&type=script&lang=js"
export * from "./elecBoardContainer.vue?vue&type=script&lang=js"

import "./elecBoardContainer.vue?vue&type=style&index=0&id=563520f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563520f0"]])

export default __exports__